import { Button } from 'src/components/atoms';
import { Button as MantineButton } from '@mantine/core'
import { useStyles } from './primaryAlertModal.styles';
import { CustomModal } from '../../../components/customModal';

export type AlertModalPropsType = {
  opened: boolean,
  onClose: ()=> void,
  onPrimaryBtnClick?: ()=> void,
  onSecondaryBtnClick?: ()=> void,
  title: string,
  description: string,
  pBtnText?: string,
  sBtnText?: string,
  className?: any
};
export const PrimaryAlertModal = (props: AlertModalPropsType) => {
  const {
    opened, onClose, onPrimaryBtnClick, onSecondaryBtnClick, title, description, pBtnText, sBtnText, className,
  } = props;
  const { classes, cx } = useStyles();
  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      className={cx(classes.modalContentWrapper, className)}
    >
      <div>
        <h2 className="content_xl_semibold">
          {' '}
          {title}
        </h2>
        <p className={classes.subtext}>{description}</p>
      </div>
      <div className={classes.modalBtnContainer}>
        {sBtnText && (
          <MantineButton
            type="button"
            onClick={onSecondaryBtnClick}
            variant="outline"
            radius="8px"
            mt={16}
          >
            {sBtnText}
          </MantineButton>
        )}
        {pBtnText && (
          <Button
            type="button"
            className={classes.modalBtn}
            onClick={onPrimaryBtnClick}
          >
            {pBtnText}
          </Button>
        )}
      </div>
    </CustomModal>
  );
};

PrimaryAlertModal.defaultProps = {
  onPrimaryBtnClick: () => {},
  onSecondaryBtnClick: () => {},
  pBtnText: '',
  sBtnText: '',
  className: null,
};

export default PrimaryAlertModal;
